"use client";

import styles from "./index.module.scss";
import { useEffect, useRef } from "react";

type Props = {
  headings: { level: string; title: string; href: string }[];
};

export const SidebarTableOfContents = (props: Props) => {
  const { headings } = props;
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!headings) return;
    const headingElements = document.querySelectorAll(".znc h2,.znc h3");
    if (!headingElements.length) return;

    const options = {
      root: null,
      rootMargin: "0% 0px -90% 0px",
      threshold: 0,
    };
    const observer = new IntersectionObserver(doWhenIntersect, options);
    headingElements.forEach((element) => {
      observer.observe(element);
    });

    function doWhenIntersect(entries: IntersectionObserverEntry[]) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          activateIndex(entry.target);
        }
      });
    }

    function activateIndex(element: Element) {
      if (!ref.current) return;
      const currentActiveIndex = ref.current.querySelectorAll("p");
      if (currentActiveIndex !== null) {
        currentActiveIndex.forEach((item) => {
          item.classList.remove(styles.isActive);
        });
      }
      const findResult = (headings || []).find(
        (item) => element.getAttribute("id") === item.href
      );
      if (!findResult) return;

      const newActiveIndex = ref.current?.querySelector(
        `a[href='#${findResult.href}']`
      );
      if (!newActiveIndex?.parentElement) return;
      newActiveIndex.parentElement.classList.add(styles.isActive);

      if (
        newActiveIndex.parentElement.offsetTop >
        ref.current.clientHeight + ref.current.scrollTop
      ) {
        ref.current.scrollTop += ref.current.clientHeight;
      }
      if (newActiveIndex.parentElement.offsetTop < ref.current.scrollTop) {
        ref.current.scrollTop -= ref.current.clientHeight;
      }
    }
  }, [headings]);

  return (
    <div className={styles.tableOfContents} ref={ref}>
      <div className={styles.tableOfContentsInner}>
        {headings.map((item) => {
          return (
            <p
              className={
                item.level === "H2" ? styles.topListItem : styles.secondListItem
              }
              key={item.href}
            >
              <a href={`#${item.href}`}>{item.title}</a>
            </p>
          );
        })}
      </div>
    </div>
  );
};
